import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export type FavorableTariffsType = {
    tariffs: string[];
    variant: string | null;
};
/** CLOUDWEB-18694: Синхронизовать тарифы для авторизованных и неавторизованных на /promo/quota */
// tempexp_18694-next-line
const favorableTariffsAnonymous: FavorableTariffsType = getFeature('favorable-tariffs-anonym');

const favorableTariffsDesktop: string[] = ANONYM_USER ? favorableTariffsAnonymous?.tariffs : getFeature('favorable-tariffs');

/** CLOUDWEB-16373: [WEB] Подборка выгодных тарифов */
// tempexp_16373-next-line
export const favorableTariffs: string[] = !IS_MOBILE_BROWSER ? favorableTariffsDesktop || [] : [];

/** CLOUDWEB-16799: [IOS] Подборка выгодных тарифов */
// tempexp_16799-start
const defaultFavoribleTariffsIos: FavorableTariffsType = { tariffs: [], variant: null };

export const iosFavorableTariffs: FavorableTariffsType =
    IS_IOS_MOBILE && IS_WEBVIEW ? getFeature('favorable-tariffs-ios') || defaultFavoribleTariffsIos : defaultFavoribleTariffsIos;
// tempexp_16799-end

// tempexp_18694-start
if (ANONYM_USER && !IS_MOBILE_BROWSER && favorableTariffsAnonymous) {
    registerExperiment('anonym-tariffs', favorableTariffsAnonymous.variant, [
        AnalyticEventNames.TARIFFS_SHOWN,
        AnalyticEventNames.TARIFF_CLICK,
    ]);
}
// tempexp_18694-end
